import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton, BaasicTable, TableFilter, EmptyState, BaasicModal } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { isSome } from 'core/utils';
import { ApplicationListLayout, Content } from 'core/layouts';
import {UserEmailSignatureEditModal } from 'application/user/pages';

const UserListTemplate = function({ userViewStore }) {
    const {
        tableStore,
        routes,
        queryUtility,
        emailSignatureEditModal,
        authorization
    } = userViewStore;

    return (
        <ApplicationListLayout store={userViewStore} authorization={authorization}>
            <Content emptyRenderer={renderEmpty(routes)} >
                <div className="u-mar--bottom--sml">
                    <TableFilter queryUtility={queryUtility}>
                    </TableFilter>
                </div>
                <div className="card--table">
                <BaasicTable
                    authorization={authorization}
                    tableStore={tableStore}
                    actionsComponent={renderActions}
                />
                </div>
                <BaasicModal modalParams={emailSignatureEditModal}  className="modal__content modal--lrg"> 
                    <UserEmailSignatureEditModal />
                </BaasicModal>
            </Content>
        </ApplicationListLayout>
    )
};

function renderEmpty(routes) {
    return <EmptyState image={EmptyIcon} title='USER.LIST.EMPTY_STATE.TITLE' actionLabel='USER.LIST.EMPTY_STATE.ACTION' callToAction={routes.create} />
}

UserListTemplate.propTypes = {
    userViewStore: PropTypes.object.isRequired
};

function renderActions({ item, actions, authorization }) {
    if (!isSome(actions)) return null;

    const { onEdit, onLock, onUnlock, onApprove, onDisapprove, onPreview, onEmailSignatureEdit } = actions;
    if (!isSome(onEdit) && !isSome(onPreview) && !isSome(onLock) && !isSome(onUnlock) && !isSome(onApprove) && !isSome(onDisapprove)) return null;

    return (
        <td className="table__body--data right">
            <div className="table__icons">
                {isSome(onEmailSignatureEdit) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--envelope--grey u-icon--sml'
                        label='USER.LIST.BUTTON.EMAIL_SIGNATURE'
                        onlyIcon={true}
                        onClick={() => onEmailSignatureEdit(item)}>
                    </BaasicButton>
                ) : null}   
                {isSome(onPreview) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.read : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--preview u-icon--sml'
                        label='USER.LIST.BUTTON.PREVIEW'
                        onlyIcon={true}
                        onClick={() => onPreview(item)}>
                    </BaasicButton>
                ) : null}   
                {isSome(onEdit) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--edit u-icon--sml'
                        label='USER.LIST.BUTTON.EDIT'
                        onlyIcon={true}
                        onClick={() => onEdit(item)}>
                    </BaasicButton>
                ) : null}
                {(item.isApproved) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--approved u-icon--sml'
                        label='USER.LIST.BUTTON.DISAPPROVE'
                        onlyIcon={true}
                        onClick={() => onDisapprove(item)}>
                    </BaasicButton>
                ) : (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--unapproved u-icon--sml'
                        label='USER.LIST.BUTTON.APPROVE'
                        onlyIcon={true}
                        onClick={() => onApprove(item)}>
                    </BaasicButton>
                )}
                {(item.isLockedOut) ? (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--locked u-icon--sml'
                        label='USER.LIST.BUTTON.LOCK'
                        onlyIcon={true}
                        onClick={() => onUnlock(item)}>
                    </BaasicButton>
                ) : (
                    <BaasicButton
                        authorization={authorization ? authorization.update : null}
                        className="btn btn--icon"
                        icon='u-icon u-icon--unlocked u-icon--sml'
                        label='USER.LIST.BUTTON.UNLOCK'
                        onlyIcon={true}
                        onClick={() => onLock(item)}>
                    </BaasicButton>
                )}
            </div>
        </td>
    )
}

renderActions.propTypes = {
    item: PropTypes.object,
    actions: PropTypes.object,
    authorization: PropTypes.any
};

export default defaultTemplate(UserListTemplate);

